import { NavSectionBlock } from "./components/NavSectionBlock";
import { SidebarProfile } from "./components/SidebarProfile";
import { SidebarConfigProvider, useSidebarConfig } from "./SidebarConfigContext";
import { SafecheckLogo } from "@/modules/safecheck/components/SafecheckLogo";
import { useSidebar } from "@/modules/dashboard-shell/SidebarProvider";
import { cn } from "@/shared/lib/cn";
import { X } from "lucide-react";

function MainSidebarNav() {
  const config = useSidebarConfig();

  return (
    <div className="space-y-5">
      {config.sections.map((section) => (
        <NavSectionBlock key={section.id} section={section} />
      ))}
    </div>
  );
}

export function MainSidebar() {
  const { isOpen, close } = useSidebar();

  return (
    <aside
      className={cn(
        "main-sidebar fixed inset-y-0 left-0 z-50 flex h-[100dvh] w-[var(--sidebar-width)] flex-col overflow-hidden bg-sidebar-bg transition-all duration-300 ease-in-out",
        "lg:sticky lg:top-0 lg:z-40 lg:h-screen lg:self-start",
        isOpen
          ? "translate-x-0 shadow-[var(--shadow)] dark:shadow-none"
          : "-translate-x-full lg:w-0 lg:translate-x-0 lg:overflow-hidden lg:shadow-none",
      )}
    >
      <SidebarConfigProvider>
        <div className="sidebar-inner flex h-full min-h-0 w-[var(--sidebar-width)] shrink-0 flex-col bg-sidebar-bg px-4 py-6">
          <header className="sidebar-header sticky top-0 z-10 -mx-4 shrink-0 bg-sidebar-bg px-4">
            <div className="mb-2 flex items-center justify-between gap-2">
              <SafecheckLogo size="lg" variant="onDark" className="justify-center lg:mx-auto" />
              <button
                type="button"
                onClick={close}
                aria-label="Fermer le menu"
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-sidebar-muted transition-colors hover:bg-sidebar-hover hover:text-sidebar-fg lg:hidden"
              >
                <X size={20} />
              </button>
            </div>
            <SidebarProfile />
          </header>
          <nav
            aria-label="Navigation principale"
            className="sidebar-nav sidebar-nav-scroll min-h-0 flex-1 overflow-y-auto overflow-x-hidden bg-sidebar-bg py-1"
          >
            <MainSidebarNav />
          </nav>
        </div>
      </SidebarConfigProvider>
    </aside>
  );
}
